<template>
<div>
  <Head :active="'FAQ'" />
  <banner />
<div :class="{join:true,joiner:joinershow}">
  <div class="item">
    <div class="item_img">
      <img style="width:100%" :src="join.ABOUT_IMG_ADDRESS" alt="">
    </div>
    <div class="item_text">
      <p style="font-size:18px;color:rgb(56,55,53)">{{join.ABOUT_NAME}}</p>
      <br>
      <p>地址:{{join.ABOUT_ADDRESS}}</p>
      <br>
      <p>电话:{{join.ABOUT_TEL}}</p>
      <br>
      <!-- <p>QQ:123456789</p> -->
      <!-- <br> -->
      <p>手机:{{join.ABOUT_PHONE}}</p>
    </div>
    <div v-if="join.ABOUT_IMG_QR != ''" class="item_qr">
      <img style="width:200px；height:200px" :src="join.ABOUT_IMG_QR" alt="">
      <p style="line-height:30px">{{join.ABOUT_IMG_IM}}</p>
    </div>
  </div>
</div>
  <div class="link_container">
    <div :class="{linkcon:true,linkconer:linkconershow}">
      <p><span>{{join.ABOUT_IMG_TITLE}}</span></p>
      <p style="color:#818181">{{join.ABOUT_IMG_TEXT}}</p>
    </div>
    <div class="link_box">
      <!-- <div> -->
        <div :class="{pin:true, piner:pinershow}">
          <div><Icon style="font-size: 30px; padding:2px 0 20px 0" type="md-call" /></div>
          <div>{{join.ABOUT_TEL}}</div>
        </div>
        <div v-if="join.ABOUT_EMAIL != ''" :class="{pin:true, pinone:pinershow}">
          <div><Icon style="font-size: 30px; padding:2px 0 20px 0" type="md-mail" /></div>
          <div>{{join.ABOUT_EMAIL}}</div>
        </div>
        <div :class="{pin:true, piner:pinershow}">
          <div><Icon style="font-size: 30px; padding:2px 0 20px 0" type="md-pin" /></div>
          <div>{{join.ABOUT_ADDRESS}}</div>
        </div>
      <!-- </div> -->
    </div>
  </div>
  <Footer />
</div>
</template>

<script>
import axios from 'axios'
import Head from '../../components/header.vue'
import banner from '../../components/banner.vue'
import Footer from '../../components/footer.vue'
// import Less from '../../../static/less/less.less'
export default {
  components: {
    Head,
    banner,
    Footer
  },
  data () {
    return {
      joinershow: false,
      linkconershow: false,
      pinershow: false,
      join: []
    }
  },
  mounted () {
    window.addEventListener('scroll', this.handleScroll)
    axios.get(`https://bidguamgt-product.oss-cn-beijing.aliyuncs.com/statics/json/configes.json`)
      .then(response => {
        // this.center = response.data.CENTER
        this.join = response.data.ABOUT
        // this.twocons = response.data.CENTER.CONTER_TWO
        // console.log(this.center)
      })
  },
  methods: {
    handleScroll () {
      this.currentScroll = window.pageYOffset
      // console.log(this.currentScroll)
      if (this.currentScroll >= 200) {
        // console.log(this.currentScroll)
        this.joinershow = true
      }
      if (this.currentScroll >= 400) {
        this.linkconershow = true
      }
      if (this.currentScroll >= 400) {
        this.pinershow = true
      }
    }
  }
}
</script>

<style lang="less" scoped>
@import url('../../../static/less/less.css');
@media only screen and (min-width: 960px) {
  .item {
    display: flex;
    .item_img {
      width: 50%;
    }
    .item_text {
      padding: 50px 0 50px 50px;
      width: 26%;
    }
    .item_qr {
      width: 24%;
    }
  }
  .pin {
    width: 30%;
  }
}
@media only screen and (min-width: 767px) and (max-width: 960px) {
  .item {
    display: inline-flex;
    .item_img {
    width: 100%;
    }
    .item_text {
      padding: 50px 0 50px 20px;
      width: 100%;
    }
    .item_qr {
      width: 100%;
    }
  }
  .pin {
    width: 30%;
  }
}
//<1100
@media only screen and (max-width: 767px) {
  .item {
    display: inline-table;
    // display: inline;
    .item_img {
      width: 100%;
    }
    .item_text {
      padding: 50px 0 50px 20px;
      width: 100%;
    }
    .item_qr {
      width: 100%;
    }
  }
  .pin {
    width: 80%;
    // opacity: 0;
  }
}
.button {
  background-color: #2ec4b6;
  width: 100px;
  height: 30px;
  border: none;
  cursor: pointer;
  color: #fdfffc;
}
.joiner {
  animation-name: fadeUp;
  visibility: visible;
  animation-duration: 2s;
  opacity: 1 !important;
}
.join {
  padding: 90px 0;
  width: 96%;
  max-width: 1200px;
  margin: 0 auto;
  text-align: center;
  opacity: 0;
  .item {
    padding: 0px;
    margin: 65px 0px 0px;
    width: 100%;
    height: 298px;
    border: 1px solid rgb(217, 217, 217);
    color: rgb(126, 126, 126);
    font-size: 14px;
    line-height: 18px;
    // opacity: 0;
  }
  .item_img {
    border-width: 0px 1px 0px 0px;
    border-right-style: solid;
    border-right-color: #d9d9d9;
    overflow: hidden;
    display: block;
    float: left;
    height: 298px;
    // width: 50%;
    img {
      height: 298px;
      // width: 100%;
    }
  }
  .item_text {
    float: left;
    // width: 25%;
    // padding: 70px 0 50px 50px;
    text-align: left;
  }
  .item_qr {
    // width: 25%;
    padding-top: 40px;
    img {
      height: 200px;
      width: 200px;
    }
  }
}
.link_container {
  background-color: #121114;
  padding: 76px 6px 110px;
  text-align: center;
  font-size: 16px;
  line-height: 1.5;
  .linkconer {
    animation-name: fadeUp;
    visibility: visible;
    animation-duration: 2s;
    opacity: 1 !important;
  }
  .linkcon {
    margin: 26px 0 56px 0;
    opacity: 0;
    p {
      margin: 10px;
    }
    span {
      margin-bottom: 10px;
      font-size: 36px;
      color: #3c94f1;
    }
  }
  .link_box {
    margin: 30px 10%;
    display: flex;
    flex-wrap: wrap;
    overflow: hidden;
    justify-content: center;
  .piner {
    animation-name: fadeLeft;
    visibility: visible;
    animation-duration: 2s;
    opacity: 1 !important;
  }
  .pinone {
    animation-name: fadeRight;
    visibility: visible;
    animation-duration: 2s;
    opacity: 1 !important;
  }
    .pin {
      opacity: 0;
      padding: 20px 3px;
      margin: 0 0 3px 26px;
      // width: 30%;
      float: left;
      text-align: center;
      color: #b7b7b7;
      background-color: #2e2e2e;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/join/join.vue